import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import AssignInvoiceCriteriaMain from "presentation/view/container/AssignInvoiceCriteria/AssignInvoiceCriteriaMain";

CommonEntrypoint(<AssignInvoiceCriteriaMain />)